import * as sum from 'lodash/sum';

import { FactOperator } from './fact-operator';

export class AdditionOperator implements FactOperator {
	public calculate(values: number[]): number {
		return sum(values);
	}
}
